import React, { useEffect, useState } from "react";
import {
  FormLabel,
  Grid,
  TextField,
  InputAdornment,
  Typography,
  Divider,
} from "@material-ui/core";
import { fieldValidations, initialValues } from "./inputValues";
import RegularButton from "components/CustomButtons/Button";
import { useForm } from "hooks/useForm";
import { blue, red } from "@material-ui/core/colors";
import PersonIcon from "@material-ui/icons/Person";
import FaceIcon from "@material-ui/icons/Face";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { useToggle } from "hooks/useToggle";
import { useDispatch, useSelector } from "react-redux";
import { useThemeMode } from "hooks/useThemeMode";
import { loginAction } from "redux/actions/login/loginActions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import LoopIcon from "@material-ui/icons/Loop";
import { animations } from "helpers/animations";
import LockIcon from "@material-ui/icons/Lock";
import { resetUserPassword } from "redux/actions/login/loginActions";
import { loginMSAction } from "redux/actions/login/loginActions";
import MailIcon from "@mui/icons-material/Mail";
import MicrosoftIcon from "@mui/icons-material/Microsoft";
import { useSearch } from "hooks/useSearch";
import { saveItemLocalStorage } from "helpers/localstorageTool";
import { IS_PROD } from "utils/variables";

export const FormLogin = ({ isResetPass, setIsResetPassword }) => {
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { isDark } = useThemeMode();
  const iconColor = isDark ? blue[300] : blue[900];

  const { setSnackbar } = useSearch();
  const {
    inputValues,
    handleInputOnChange,
    cleanForm,
    runValidates,
    fieldErrors,
  } = useForm(initialValues, fieldValidations);
  const [showPass, setShowPass] = useToggle();

  const [okUser, setUserOk] = useState(true);
  const [_, setMSLog] = useState(false);

  const { username, password, email } = inputValues;
  const dispatch = useDispatch();

  const hist = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.removeItem('isAvailable')
    saveItemLocalStorage('isOffline', true)
    if (IS_PROD) {
      if (!email.includes("@") && !email.includes("."))
        return setSnackbar("Correo Invalido")
      dispatch(loginMSAction({ email }, hist));
      return;
    } else {
      if (runValidates()) return;
      dispatch(
        loginAction(
          {
            username,
            password,
          },
          hist
        )
      );
    }
  };

  const handleisResetPass = (e) => {
    e.preventDefault();
    cleanForm();
    setMSLog(false);
    setIsResetPassword();
  };

  const handleResetPassword = (e) => {
    e.preventDefault();
    if (username.length < 3) return;

    dispatch(resetUserPassword(username, setIsResetPassword));
  };

  const handleKeyPress = (event, reset = false) => {
    if (event.key === "Enter") {
      !reset ? handleSubmit(event) : handleResetPassword(event);
    }
  };

  useEffect(() => {
    if (isResetPass && username.length >= 5) {
      setUserOk(true);
    } else {
      setUserOk(false);
    }
  }, [username]);

  return (
    <form onSubmit={handleSubmit}>
      <FormLabel>{/* Nombre Formulario  */}</FormLabel>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {IS_PROD ? (
          <MicrosoftIcon
            style={{
              color: blue[500],
              transition: " .2s ease",
              fontSize: 100,
              marginBottom: 16,
            }}
          />
        ) : (
          <>
            {isResetPass ? (
              okUser ? (
                <FaceIcon
                  className={animations.fadeIn}
                  style={{
                    transition: " .2s ease",
                    fontSize: 100,
                    color: iconColor,
                  }}
                />
              ) : (
                <LockIcon
                  className={animations.fadeIn}
                  style={{
                    transition: " .2s ease",
                    fontSize: 100,
                    color: iconColor,
                  }}
                />
              )
            ) : (
              <PersonIcon
                style={{
                  transition: " .2s ease",
                  fontSize: 100,
                  color: iconColor,
                }}
              />
            )}
          </>
        )}
      </div>
      <Grid container spacing={2}>
        {IS_PROD ? (
          <>
            <Grid item xs={12}>
              <TextField
                label="Correo Electronico"
                name="email"
                value={email}
                variant="outlined"
                fullWidth
                size="small"
                onChange={handleInputOnChange}
                onKeyPress={handleKeyPress}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <MailIcon style={{ color: iconColor }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <RegularButton color="info" fullWidth onClick={handleSubmit}>
                Iniciar Sesión
              </RegularButton>
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12} sm={12}>
              <TextField
                label="Usuario"
                name="username"
                value={username}
                variant="outlined"
                fullWidth
                size="small"
                required={true}
                error={fieldErrors.username}
                helperText={fieldErrors.username || ""}
                onChange={handleInputOnChange}
                onKeyPress={handleKeyPress}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <FaceIcon style={{ color: iconColor }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              {!isResetPass ? (
                <TextField
                  label="Contraseña"
                  name="password"
                  value={password}
                  type={showPass ? "text" : "password"}
                  variant="outlined"
                  fullWidth
                  size="small"
                  required={true}
                  error={fieldErrors.password}
                  helperText={fieldErrors.password || ""}
                  onChange={handleInputOnChange}
                  onKeyPress={handleKeyPress}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        position="end"
                        onClick={setShowPass}
                        style={{ cursor: "pointer" }}
                      >
                        {!showPass ? (
                          <VisibilityIcon style={{ color: iconColor }} />
                        ) : (
                          <VisibilityOffIcon style={{ color: iconColor }} />
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              ) : (
                <Typography
                  variant="body"
                  style={{ textAlign: "center", color: red[400] }}
                >
                  Ingresa el nombre de usuario y se te enviará una nueva
                  contraseña a tu correo.
                </Typography>
              )}
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                marginTop: 32,
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              {!isResetPass ? (
                <>
                  <RegularButton
                    color="info"
                    tooltip="Aceptar"
                    onClick={handleSubmit}
                    fullWidth
                    disabled={isLoadingComp?.loginLoading}
                  >
                    {isLoadingComp?.loginLoading ? (
                      <LoopIcon
                        className={animations.rotate}
                        style={{ animationIterationCount: 5 }}
                      />
                    ) : (
                      "Iniciar sesión"
                    )}
                  </RegularButton>

                  <Divider
                    style={{
                      margin: "16px 0",
                    }}
                  />
                </>
              ) : (
                <RegularButton
                  color="info"
                  tooltip="Aceptar"
                  fullWidth
                  onClick={handleResetPassword}
                >
                  Confirmar
                </RegularButton>
              )}
              <RegularButton
                color={isResetPass ? "danger" : isDark ? "transparent" : "white"}
                tooltip="Aceptar"
                onClick={handleisResetPass}
                size="sm"
              >
                {isResetPass ? "Cancelar" : "Olvidaste tu contraseña?"}
              </RegularButton>
            </Grid>
          </>
        )}
      </Grid>
    </form>
  );
};
